import React from 'react';
import 'HELPDESK/Footer/footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';

const Footer = () => {
    return(
        <footer id="sticky-footer" className="big" id="footer">
            <div className="footer-container">
                <a style={{ float: 'left' }} href={`${config.RootUrl}/modules/helpdesk/#/help/productDocumentation`} target="_blank" rel="noopener noreferrer" className="footer-link ml-4">
                    <span className="helpBtn">
                        Product Documentation
                    </span>
                </a>
                <span className="footer-data download">Download App
                    <a href="https://play.google.com/store/apps/details?id=com.vmedulifeapp&hl=en_IN" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <span className="footer-data download">
                            <img style={{ height: 16 }} className='android-logo ml-2 img-fluid' src={process.env.PUBLIC_URL + "/assets/images/andorid_icon.png"} alt="image" />
                        </span>
                    </a>
                    <a href="https://apps.apple.com/app/vmedulife/id1606317107" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <span className="footer-data download ml-2">
                            <FontAwesomeIcon className="apple-icon" icon={['fab', 'apple']} size="lg" />
                        </span>
                    </a>
                </span>
                <a href="https://vmedulife.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-link">
                    <span className="footer-data policy">Privacy Policy</span>
                </a>
                <a href="https://vmedulife.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="footer-link">
                    <span className="footer-data terms">Terms of Use</span>
                </a>
                <a href="https://vmedulife.com/" target="_blank" rel="noopener noreferrer" className="footer-link">
                    <span className="footer-data powered-by">
                        Powered by<span className="vm" style={{ marginLeft: "0.2%" }}>vm</span><span className="edu">edu</span><span className="life">life</span>
                    </span>
                </a>
            </div>
        </footer>
    );
}

export default Footer;